import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "invalid-feedback",
  style: {"display":"block"}
}

import { useValidationErrors } from "@/composables/fields";
import PropertyPathPrefixKey from "@/types/symbols/PropertyPathPrefixKey";
import ValidationStateMapKey from "@/types/symbols/ValidationStateMapKey";
import { computed, inject, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Validation',
  props: {
	propertyPaths: {
		type: Array as PropType<string[]>,
		required: true,
	},
	matchCustomStateValue: {
		type: String,
		required: false,
	},
	fieldName: {
		type: String,
		required: true,
	},
},
  setup(__props) {

const props = __props;

const myValidationErrors = useValidationErrors(
	props.propertyPaths,
	props.matchCustomStateValue
).validationErrors;

const propertyPathPrefixKey = inject(PropertyPathPrefixKey, null);
const validationStateMap = inject(ValidationStateMapKey, null);

const prefixedPropertyPaths = computed(() => {
	const prefix = propertyPathPrefixKey?.value || "";
	//const prefix = "";

	return props.propertyPaths.map((r) => {
		const searchPath = prefix + r;
		return searchPath;
	});
});

const myValidationErrorsRenamed = computed(() => {
	if (!myValidationErrors) {
		return [];
	}
	return myValidationErrors.value
		.filter((r) => prefixedPropertyPaths.value.includes(r.propertyName))
		.map((r) => {
			const lastPart = r.propertyName.split(".").pop();
			const msg = r.errorMessage.replace('"' + lastPart + '"', `"${props.fieldName}"`);

			return {
				...r,
				errorMessage: msg,
			};
		});
});

const isInvalid = computed(() => {
	if (validationStateMap) {
		if (prefixedPropertyPaths.value.every((p) => validationStateMap.value[p] === true)) {
			return false;
		} else if (prefixedPropertyPaths.value.some((p) => validationStateMap.value[p] === false)) {
			return true;
		}
	}

	if (myValidationErrors.value.length > 0) {
		return true;
	}

	return null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", {
      isInvalid: isInvalid.value,
      propertyPaths: prefixedPropertyPaths.value
    }),
    (_unref(myValidationErrors) && _unref(myValidationErrors).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myValidationErrorsRenamed.value, (err) => {
            return (_openBlock(), _createElementBlock("div", {
              key: err.errorMessage
            }, _toDisplayString(err.errorMessage), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})